import { createI18n } from 'vue-i18n'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import zhTC from 'vxe-table/lib/locale/lang/zh-TC'
import ruru from 'vxe-table/lib/locale/lang/ru-RU'
import enUS from 'vxe-table/lib/locale/lang/en-US'

const messages = {
  zh_cn: {
    ...zhCN
  },
  zh_tw: {
    ...zhTC
  },
  ru_ru: {
    ...ruru
  },
  en: {
    ...enUS
  }
}

const i18n_table = createI18n({
  locale: 'en',
  messages,
})

export default i18n_table